import { LogoImage } from "./Logo";
import { STATE_OPTIONS } from "../data/siteData";

const NAV = [
  { label: "How It Works", href: "/#how-it-works" },
  { label: "Rate Impact Calculator", href: "/#rate-calculator" },
  { label: "Service States", href: "/#service-states" },
  { label: "Fixed vs Variable", href: "/#rates" },
  { label: "Get a Quote", href: "/#get-quote" },
  { label: "Energy Blog", href: "/blog" },
];

export default function Footer() {
  return (
    <footer className="bg-[#06132B] text-slate-400">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          <div>
            <LogoImage className="h-9 w-auto" inverted />
            <p className="mt-5 text-sm leading-relaxed max-w-sm">
              BlueSettle. Settle For Better.
            </p>
          </div>
          <div>
            <h4 className="font-display text-sm font-bold uppercase tracking-wider text-white">Explore</h4>
            <ul className="mt-5 space-y-2.5">
              {NAV.map((n) => (
                <li key={n.href}>
                  <a href={n.href} className="text-sm hover:text-[#4D94FF] transition-colors">
                    {n.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="font-display text-sm font-bold uppercase tracking-wider text-white">Service Markets</h4>
            <p className="mt-5 text-sm leading-relaxed">{STATE_OPTIONS.map((s) => s.name).join(" · ")}</p>
          </div>
        </div>

        <div className="mt-12 border-t border-white/10 pt-8">
          <p className="text-xs leading-relaxed text-slate-500 max-w-4xl">
            BlueSettle is a commercial energy procurement intermediary and is not an electric or gas utility.
            We do not generate or physically deliver energy. Customers continue to receive energy through
            their existing utility distribution networks, and utility delivery charges, taxes, and other
            regulated expenses remain separate. BlueSettle may be compensated through supplier-paid
            commissions when an eligible supply contract is placed; such compensation may be reflected in
            contracted pricing and is disclosed prior to enrollment. Illustrative scenarios and savings
            examples shown on this site are for educational purposes only and are not quotes, forecasts,
            or guarantees.
          </p>
          <div className="mt-6 flex flex-wrap gap-6 text-xs"><a href="/privacy" className="hover:text-white underline">Privacy Policy</a><a href="/terms" className="hover:text-white underline">Terms of Service</a><a href="mailto:info@bluesettle.com" className="hover:text-white">info@bluesettle.com</a></div>
          <p className="mt-6 text-xs text-slate-500">
            © {new Date().getFullYear()} BlueSettle. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
